export default [
  {
    path: '/combined/data',
    name: 'combined-data',
    component: () => import('@/views/system/combined-data/index.vue'),
    meta: {
      pageTitle: "数据组管理",
      breadcrumb: [
        { text: "系统配置", active: true },
      ],
    },
  },
  {
    path: '/group/data/:id',
    name: 'group-data',
    component: () => import('@/views/system/group-data/index.vue'),
    meta: {
      pageTitle: "数据组数据",
      breadcrumb: [
        { text: "系统配置", active: true, },
        { text: "数据组管理", to: { name: 'combined-data' } },
      ],
    },
    beforeEnter(to, _, next) {
      if (to.params.id >= 0) { next() } else next({ name: 'error-404' })
    },
  },
]
